

















import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import DatePickerWithInput from "@/components/form/input/DatePickerWithInput.vue";

const module = namespace("projectValuationReport");

@Component({
  components: {
    DatePickerWithInput,
  },
})
export default class ProjectValuationPage14Edit extends Vue {
  @module.Getter("getBtScoreQuote")
  btScoreQuote!: string;
  @module.Mutation("setBtScoreQuote")
  setBtScoreQuote!: (value: string) => void;
}
